'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const d3=require('d3');
const _=require('pulsar-utils/dist-es6/_');
const StatisticsPanelHelpers=require('../../../../../dist-es6/client/directives/statisticsPanels/statisticsPanelHelpers');
const BaseTwoAxisGraphPanelDirective=require('../../../../../dist-es6/client/directives/statisticsPanels/baseTwoAxisGraphPanelDirective');
const BaseTwoAxisGraphPanelDirectiveController=BaseTwoAxisGraphPanelDirective.DirectiveController;let

DaysSinceLastIncidentGraphPanelDirective=function(_BaseTwoAxisGraphPane){_inherits(DaysSinceLastIncidentGraphPanelDirective,_BaseTwoAxisGraphPane);function DaysSinceLastIncidentGraphPanelDirective(){_classCallCheck(this,DaysSinceLastIncidentGraphPanelDirective);return _possibleConstructorReturn(this,_BaseTwoAxisGraphPane.apply(this,arguments))}_createClass(DaysSinceLastIncidentGraphPanelDirective,[{key:'controller',get:function()
{return DaysSinceLastIncidentGraphPanelDirectiveController}}]);return DaysSinceLastIncidentGraphPanelDirective}(BaseTwoAxisGraphPanelDirective);let


DaysSinceLastIncidentGraphPanelDirectiveController=function(_BaseTwoAxisGraphPane2){_inherits(DaysSinceLastIncidentGraphPanelDirectiveController,_BaseTwoAxisGraphPane2);
function DaysSinceLastIncidentGraphPanelDirectiveController($scope,$timeout,$element,elementService){_classCallCheck(this,DaysSinceLastIncidentGraphPanelDirectiveController);var _this2=_possibleConstructorReturn(this,
_BaseTwoAxisGraphPane2.call(this,$scope,$timeout,$element,elementService));

_this2._drawPath=d3.svg.line().
interpolate('linear-closed').
x(function(){let[time,dayDifference]=arguments.length>0&&arguments[0]!==void 0?arguments[0]:[0,0];return _this2._xScale(time)}).
y(function(){let[time,dayDifference]=arguments.length>0&&arguments[0]!==void 0?arguments[0]:[0,0];return _this2._yScale(dayDifference)});

_this2._flatLineToStart=d3.svg.line().
interpolate('linear-closed').
x(function(){let[time,dayDifference]=arguments.length>0&&arguments[0]!==void 0?arguments[0]:[0,0];return _this2._xScale(time)}).
y(function(){let[time,dayDifference]=arguments.length>0&&arguments[0]!==void 0?arguments[0]:[0,0];return _this2._yScale(0)});

_this2._graphAreaInnerPadding.left=0;
_this2._yScaleNiceDomainRounding=5;
_this2._numYAxisTicks=5;return _this2;
}DaysSinceLastIncidentGraphPanelDirectiveController.prototype.


_setupGraphs=function _setupGraphs(){
if(!_.exists(this._gradient)){
this._gradient=this._svgDefs.
append('linearGradient').
attr({
id:`gradient-${this.panelId}`,
x1:'0%',
x2:'0%',
y1:'0%',
y2:'100%'});


this._gradient.append('stop').
attr({
"stop-color":'#62BAEA',
offset:'0%'});


this._gradient.append('stop').
attr({
"stop-color":'#DAF2FF',
offset:'100%'});

}
};DaysSinceLastIncidentGraphPanelDirectiveController.prototype.






_setupInitialState=function _setupInitialState(){var _this3=this;
this._graphedPath=this._graphAreaGroup.
selectAll('path').
data([this.context]);

this._graphedPath.
enter().
append('path').
attr({
d:function(d){return _this3._flatLineToStart(d)},
fill:`url(#gradient-${this.panelId})`,
"clip-path":`url(#clip-path-${this.panelId})`});


this._graphedPath.
exit().
remove();

this._graphAreaClipPathRect.
attr({
width:this._xScale.range()[1]-0.5,
height:this._yScale.range()[0]-0.5});

};DaysSinceLastIncidentGraphPanelDirectiveController.prototype.


_updateState=function _updateState(isResizing){var _this4=this;
const pathWithOrWithoutTransition=this.preventAnimations||isResizing?
this._graphedPath:
this._graphedPath.transition().duration(StatisticsPanelHelpers.DefaultTransitionDuration);

pathWithOrWithoutTransition.
attr({
d:function(d){return _this4._drawPath(d)}});

};return DaysSinceLastIncidentGraphPanelDirectiveController}(BaseTwoAxisGraphPanelDirectiveController);






module.exports=DaysSinceLastIncidentGraphPanelDirective;
//# sourceMappingURL=daysSinceLastIncidentGraphPanelDirective.js.map
